import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

interface NavItem {
  label: string;
  onClick: () => void;
  isActive: boolean;
  title?: string;
}

interface NavDropdownProps {
  label: string;
  items: NavItem[];
  isActive?: boolean;
}

export const NavDropdown: React.FC<NavDropdownProps> = ({ label, items, isActive }) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button
          className={`group inline-flex items-center justify-center py-2 px-4 text-sm font-semibold transition-all duration-300 rounded-full whitespace-nowrap ${isActive
              ? 'bg-brand-primary text-white shadow-md'
              : 'text-slate-500 hover:text-brand-primary hover:bg-slate-100'
            }`}
        >
          <span>{label}</span>
          <ChevronDownIcon
            className={`ml-2 h-5 w-5 transition-transform duration-200 ${isActive ? 'text-white' : 'text-slate-400 group-hover:text-brand-primary'
              }`}
            aria-hidden="true"
          />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute left-0 mt-2 w-56 origin-top-left divide-y divide-slate-100 rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 overflow-hidden">
          <div className="px-1 py-1">
            {items.map((item) => (
              <Menu.Item key={item.label}>
                {({ active }) => (
                  <button
                    onClick={item.onClick}
                    title={item.title}
                    className={`${active || item.isActive
                        ? 'bg-slate-100 text-brand-primary'
                        : 'text-slate-700'
                      } group flex w-full items-center rounded-lg px-3 py-2.5 text-sm font-medium transition-colors`}
                  >
                    {item.label}
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
